import {inject} from '@angular/core';
import {ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot} from '@angular/router';
import {IndicatorService} from '../../apiModule1';

export const indicatorsResolver: ResolveFn<any> = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
  service: IndicatorService = inject(IndicatorService)) => {
  return service.apiIndicatorGet({}, 'body', false, {transferCache: false});
};
